export default __webpack_public_path__ + "static/src/assets/images/icons/nav_icon_e-message_normal.png";